/**
 * Conversión entre ISO UTC (API) y datetime-local del programador D28D.
 * Siempre interpreta la hora del formulario como America/Bogota (hora Colombia),
 * independiente de la zona horaria del navegador del admin.
 */
import {
  D28D_SCHEDULE_TZ,
  formatDateTimeInScheduleTz,
  scheduleTzLocalToUtcIso,
} from './d28dScheduleTimezone.js';

export { D28D_SCHEDULE_TZ };

function pad(n) {
  return String(n).padStart(2, '0');
}

/** ISO o Date → valor para input datetime-local (hora Colombia / D28D). */
export function formatDateTimeLocal(value) {
  return formatDateTimeInScheduleTz(value, D28D_SCHEDULE_TZ);
}

/** datetime-local (hora Colombia) → ISO UTC para API. */
export function toApiDateTime(localValue) {
  if (!localValue) return '';
  const iso = scheduleTzLocalToUtcIso(localValue, D28D_SCHEDULE_TZ);
  if (iso) return iso;
  const d = new Date(localValue);
  if (Number.isNaN(d.getTime())) return String(localValue);
  return d.toISOString();
}

export function addMinutesToLocalValue(localValue, minutes) {
  if (!localValue) return '';
  const iso = scheduleTzLocalToUtcIso(localValue, D28D_SCHEDULE_TZ);
  if (!iso) return '';
  const d = new Date(iso);
  d.setUTCMinutes(d.getUTCMinutes() + Number(minutes) || 0);
  return formatDateTimeInScheduleTz(d.toISOString(), D28D_SCHEDULE_TZ);
}

function pad2(n) {
  return String(n).padStart(2, '0');
}

/** Partes de un valor local para UI (fecha + hora 12h Colombia). */
export function parseScheduleLocalParts(value) {
  const local = formatDateTimeLocal(value);
  const m = String(local).match(/^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})/);
  if (!m) {
    return { date: '', hour12: 10, minute: 0, period: 'a.m.' };
  }
  const hour24 = Number(m[2]);
  const minute = Number(m[3]);
  const period = hour24 >= 12 ? 'p.m.' : 'a.m.';
  let hour12 = hour24 % 12;
  if (hour12 === 0) hour12 = 12;
  return { date: m[1], hour12, minute, period };
}

/** Construye YYYY-MM-DDTHH:mm (24h interno) desde controles de UI. */
export function buildScheduleLocalValue({ date, hour12, minute, period }) {
  if (!date) return '';
  let h = Number(hour12);
  if (!Number.isFinite(h) || h < 1 || h > 12) h = 12;
  const isPm = String(period || '').toLowerCase().startsWith('p');
  let hour24 = h % 12;
  if (isPm) hour24 += 12;
  const min = Math.min(59, Math.max(0, Number(minute) || 0));
  return `${date}T${pad2(hour24)}:${pad2(min)}`;
}
